var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "22px",
    viewBox: "0 0 40 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Knees") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-42",
    transform: "translate(-196.000000, -252.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Body---Selections",
    transform: "translate(175.074098, 42.681852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5560353,209.318148 L38.925902,231.318148 L20.925902,231.318148 C21.5160229,226.243872 21.8110834,222.453545 21.8110834,219.947166 C21.8110834,217.440788 21.6503698,213.897782 21.3289426,209.318148 L39.5560353,209.318148 Z M59.874306,209.318148 C59.7386713,213.897782 59.6708539,217.440788 59.6708539,219.947166 C59.6708539,222.453545 59.9659144,226.243872 60.5560353,231.318148 L60.5560353,231.318148 L42.5560353,231.318148 L41.925902,209.318148 Z",
    id: "Knees"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnees);
export default __webpack_public_path__ + "static/media/Knees.d3b8f18d154064b06d87657f53fb2885.svg";
export { ForwardRef as ReactComponent };